import React, { useState, useEffect, useRef } from 'react';
import { Search, User, Building, DollarSign, CreditCard, Calculator, FileText, AlertCircle, CheckCircle, Download } from 'lucide-react';
import html2pdf from 'html2pdf.js';

const CalculadoraComercialPayefy = () => {
  // Base de datos COMPLETA con datos variables incluidos
  const fullDatabase = {
    "mccDatabase": [
      { "mcc": 5399, "giro": "Agregadores", "tdPiso": 1.65, "tcPiso": 2.36, "tdCosto": 1.55, "tcCosto": 2.26, "tdVariable": 1.35, "tcVariable": 2.06 },
      { "mcc": 8398, "giro": "Beneficencia", "tdPiso": 0.60, "tcPiso": 0.60, "tdCosto": 0.50, "tcCosto": 0.50, "tdVariable": 0.30, "tcVariable": 0.30 },
      { "mcc": 8220, "giro": "Colegios y Universidades", "tdPiso": 1.25, "tcPiso": 1.75, "tdCosto": 1.15, "tcCosto": 1.65, "tdVariable": 0.95, "tcVariable": 1.45 },
      { "mcc": 8211, "giro": "Educación Básica", "tdPiso": 0.60, "tcPiso": 0.60, "tdCosto": 0.50, "tcCosto": 0.50, "tdVariable": 0.30, "tcVariable": 0.30 },
      { "mcc": 7032, "giro": "Entretenimiento - Parques", "tdPiso": 1.75, "tcPiso": 1.82, "tdCosto": 1.65, "tcCosto": 1.72, "tdVariable": 1.45, "tcVariable": 1.52 },
      { "mcc": 7941, "giro": "Entretenimiento - Eventos", "tdPiso": 1.75, "tcPiso": 1.82, "tdCosto": 1.65, "tcCosto": 1.72, "tdVariable": 1.45, "tcVariable": 1.52 },
      { "mcc": 5912, "giro": "Farmacias", "tdPiso": 1.55, "tcPiso": 1.88, "tdCosto": 1.45, "tcCosto": 1.78, "tdVariable": 1.25, "tcVariable": 1.58 },
      { "mcc": 7011, "giro": "Hoteles", "tdPiso": 1.60, "tcPiso": 2.18, "tdCosto": 1.50, "tcCosto": 2.08, "tdVariable": 1.30, "tcVariable": 1.88 },
      { "mcc": 5541, "giro": "Gasolineras", "tdPiso": 1.10, "tcPiso": 1.65, "tdCosto": 1.00, "tcCosto": 1.55, "tdVariable": 0.80, "tcVariable": 1.35 },
      { "mcc": 4900, "giro": "Gobierno", "tdPiso": 1.25, "tcPiso": 1.65, "tdCosto": 1.15, "tcCosto": 1.55, "tdVariable": 0.95, "tcVariable": 1.35 },
      { "mcc": 742, "giro": "Médicos y Dentistas - General", "tdPiso": 0.60, "tcPiso": 0.60, "tdCosto": 0.50, "tcCosto": 0.50, "tdVariable": 0.30, "tcVariable": 0.30 },
      { "mcc": 8011, "giro": "Médicos y Dentistas - Clínicas", "tdPiso": 0.60, "tcPiso": 0.60, "tdCosto": 0.50, "tcCosto": 0.50, "tdVariable": 0.30, "tcVariable": 0.30 },
      { "mcc": 8021, "giro": "Médicos - Solo Débito", "tdPiso": 0.60, "tcPiso": null, "tdCosto": 0.50, "tcCosto": null, "tdVariable": 0.30, "tcVariable": null },
      { "mcc": 5422, "giro": "Miscelánea", "tdPiso": 0.90, "tcPiso": 0.85, "tdCosto": 0.80, "tcCosto": 0.75, "tdVariable": 0.60, "tcVariable": 0.55 },
      { "mcc": 6012, "giro": "Instituciones Financieras", "tdPiso": 1.80, "tcPiso": 2.20, "tdCosto": 1.70, "tcCosto": 2.10, "tdVariable": 1.50, "tcVariable": 1.90 },
      { "mcc": 4215, "giro": "Courier / Mensajería", "tdPiso": 1.80, "tcPiso": 2.18, "tdCosto": 1.70, "tcCosto": 2.08, "tdVariable": 1.50, "tcVariable": 1.88 },
      { "mcc": 5815, "giro": "Digital Goods - Juegos", "tdPiso": 1.80, "tcPiso": 2.18, "tdCosto": 1.70, "tcCosto": 2.08, "tdVariable": 1.50, "tcVariable": 1.88 },
      { "mcc": 5816, "giro": "Digital Goods - Apps POS", "tdPiso": 1.80, "tcPiso": 2.18, "tdCosto": 1.70, "tcCosto": 2.08, "tdVariable": 1.50, "tcVariable": 1.88 },
      { "mcc": 7297, "giro": "Servicios Educativos", "tdPiso": 1.80, "tcPiso": 2.18, "tdCosto": 1.70, "tcCosto": 2.08, "tdVariable": 1.50, "tcVariable": 1.88 },
      { "mcc": 7531, "giro": "Renta de Automóviles", "tdPiso": 1.80, "tcPiso": 2.18, "tdCosto": 1.70, "tcCosto": 2.08, "tdVariable": 1.50, "tcVariable": 1.88 },
      { "mcc": 7299, "giro": "Servicios Profesionales - Otros", "tdPiso": 1.85, "tcPiso": 2.25, "tdCosto": 1.75, "tcCosto": 2.15, "tdVariable": 1.55, "tcVariable": 1.95 },
      { "mcc": 7372, "giro": "Programación / Datos", "tdPiso": 1.75, "tcPiso": 2.15, "tdCosto": 1.65, "tcCosto": 2.05, "tdVariable": 1.45, "tcVariable": 1.85 },
      { "mcc": 8734, "giro": "Laboratorios", "tdPiso": 1.65, "tcPiso": 2.18, "tdCosto": 1.55, "tcCosto": 2.08, "tdVariable": 1.35, "tcVariable": 1.88 },
      { "mcc": 8999, "giro": "Servicios Profesionales - Diversos", "tdPiso": 1.72, "tcPiso": 2.15, "tdCosto": 1.62, "tcCosto": 2.05, "tdVariable": 1.42, "tcVariable": 1.85 },
      { "mcc": 5251, "giro": "Ferreterías", "tdPiso": 0.55, "tcPiso": 0.55, "tdCosto": 0.45, "tcCosto": 0.45, "tdVariable": 0.25, "tcVariable": 0.25 },
      { "mcc": 7512, "giro": "Renta de Autos", "tdPiso": 1.75, "tcPiso": 2.23, "tdCosto": 1.65, "tcCosto": 2.13, "tdVariable": 1.45, "tcVariable": 1.93 },
      { "mcc": 5812, "giro": "Restaurantes - Comida Rápida", "tdPiso": 1.75, "tcPiso": 2.36, "tdCosto": 1.65, "tcCosto": 2.26, "tdVariable": 1.45, "tcVariable": 2.06 },
      { "mcc": 7230, "giro": "Salones de Belleza", "tdPiso": 0.60, "tcPiso": 0.60, "tdCosto": 0.50, "tcCosto": 0.50, "tdVariable": 0.30, "tcVariable": 0.30 },
      { "mcc": 5310, "giro": "Supermercados", "tdPiso": 1.75, "tcPiso": 2.18, "tdCosto": 1.65, "tcCosto": 2.08, "tdVariable": 1.45, "tcVariable": 1.88 },
      { "mcc": 4812, "giro": "Telecomunicaciones - CP", "tdPiso": 1.65, "tcPiso": 2.15, "tdCosto": 1.55, "tcCosto": 2.05, "tdVariable": 1.35, "tcVariable": 1.85 },
      { "mcc": 5094, "giro": "Metales Preciosos / Joyería", "tdPiso": 1.65, "tcPiso": 2.15, "tdCosto": 1.55, "tcCosto": 2.05, "tdVariable": 1.35, "tcVariable": 1.85 },
      { "mcc": 5111, "giro": "Papelerías", "tdPiso": 1.80, "tcPiso": 2.18, "tdCosto": 1.70, "tcCosto": 2.08, "tdVariable": 1.50, "tcVariable": 1.88 },
      { "mcc": 5462, "giro": "Panaderías", "tdPiso": 1.85, "tcPiso": 2.23, "tdCosto": 1.75, "tcCosto": 2.13, "tdVariable": 1.55, "tcVariable": 1.93 },
      { "mcc": 5499, "giro": "Tiendas de Conveniencia", "tdPiso": 1.80, "tcPiso": 2.18, "tdCosto": 1.70, "tcCosto": 2.08, "tdVariable": 1.50, "tcVariable": 1.88 },
      { "mcc": 5511, "giro": "Tiendas Departamentales", "tdPiso": 1.65, "tcPiso": 2.15, "tdCosto": 1.55, "tcCosto": 2.05, "tdVariable": 1.35, "tcVariable": 1.85 },
      { "mcc": 5651, "giro": "Tiendas de Ropa", "tdPiso": 1.80, "tcPiso": 2.18, "tdCosto": 1.70, "tcCosto": 2.08, "tdVariable": 1.50, "tcVariable": 1.88 },
      { "mcc": 5712, "giro": "Mueblerías", "tdPiso": 1.70, "tcPiso": 2.18, "tdCosto": 1.60, "tcCosto": 2.08, "tdVariable": 1.40, "tcVariable": 1.88 },
      { "mcc": 5719, "giro": "Ropa/Calzado Especializado", "tdPiso": 1.70, "tcPiso": 2.18, "tdCosto": 1.60, "tcCosto": 2.08, "tdVariable": 1.40, "tcVariable": 1.88 },
      { "mcc": 5722, "giro": "Electrodomésticos", "tdPiso": 1.70, "tcPiso": 2.18, "tdCosto": 1.60, "tcCosto": 2.08, "tdVariable": 1.40, "tcVariable": 1.88 },
      { "mcc": 5732, "giro": "Electrónica / TV", "tdPiso": 1.70, "tcPiso": 2.18, "tdCosto": 1.60, "tcCosto": 2.08, "tdVariable": 1.40, "tcVariable": 1.88 },
      { "mcc": 5811, "giro": "Restaurantes - Servicio Completo", "tdPiso": 1.75, "tcPiso": 2.13, "tdCosto": 1.65, "tcCosto": 2.03, "tdVariable": 1.45, "tcVariable": 1.83 },
      { "mcc": 5941, "giro": "Tiendas de Descuento", "tdPiso": 1.70, "tcPiso": 2.18, "tdCosto": 1.60, "tcCosto": 2.08, "tdVariable": 1.40, "tcVariable": 1.88 },
      { "mcc": 5944, "giro": "Joyerías / Relojerías", "tdPiso": 1.80, "tcPiso": 2.18, "tdCosto": 1.70, "tcCosto": 2.08, "tdVariable": 1.50, "tcVariable": 1.88 },
      { "mcc": 5995, "giro": "Pet Shops / Floristerías", "tdPiso": 1.80, "tcPiso": 2.18, "tdCosto": 1.70, "tcCosto": 2.08, "tdVariable": 1.50, "tcVariable": 1.88 },
      { "mcc": 7995, "giro": "Casinos / Apuestas", "tdPiso": 1.80, "tcPiso": 2.13, "tdCosto": 1.70, "tcCosto": 2.03, "tdVariable": 1.50, "tcVariable": 1.83 },
      { "mcc": 4789, "giro": "Transporte Aéreo", "tdPiso": 1.40, "tcPiso": 2.16, "tdCosto": 1.30, "tcCosto": 2.06, "tdVariable": 1.10, "tcVariable": 1.86, "tdFijo": 0.99, "tcFijo": 0 }
    ],
    "msiData": {
      "utilidadPayefy": 0.15,
      "modificable": false,
      "sobretasas": {
        "Emisores PROSA": { "3": 3.60, "6": 5.60, "9": 8.60, "12": 11.60, "18": 15.10, "24": "No Aplica" },
        "Banamex": { "3": 3.80, "6": 7.30, "9": 10.10, "12": 12.20, "18": 17.00, "24": 22.00 },
        "BBVA": { "3": 3.80, "6": 6.40, "9": 8.90, "12": 11.30, "18": 17.40, "24": 21.80 }
      }
    },
    "serviciosAdicionales": {
      "americanExpress": {
        "nombre": "American Express",
        "costoKushki": 2.80,
        "operacion": 0.05,
        "comercial": 0.05,
        "costoTotal": 2.90,
        "pisoMinimo": 3.00,
        "modificable": false,
        "liquidacion": "T+48h",
        "modalidades": ["CP", "CNP"]
      },
      "internacionales": {
        "nombre": "Tarjetas Internacionales",
        "costoFijo": 2.00,
        "costoVariable": 3.20,
        "operacion": 0.05,
        "comercial": 0.05,
        "costoTotalVariable": 3.30,
        "pisoMinimoVariable": 3.40,
        "modificable": false,
        "ticketPromedio": 2200,
        "distribucion": { "visa": 60, "mastercard": 40 },
        "modalidades": ["CP", "CNP"]
      }
    },
    "terminales": {
      "costos": {
        "compra": {
          "nano": { "nombre": "BP Nano", "costo": 349, "descripcion": "La más pequeña (como clip)" },
          "p2": { "nombre": "Sunmi P2", "costo": 2830, "descripcion": "CON impresora integrada" },
          "ultra": { "nombre": "BP Ultra", "costo": 2830, "descripcion": "SIN impresora, tickets por email" }
        },
        "renta": {
          "p2": { "nombre": "Sunmi P2", "costoMensual": 500, "descripcion": "CON impresora + soporte" },
          "ultra": { "nombre": "BP Ultra", "costoMensual": 500, "descripcion": "SIN impresora + soporte" }
        },
        "seguro": {
          "nano": { "nombre": "BP Nano", "costo": 279, "costoOriginal": 349, "reembolso": 279 },
          "p2": { "nombre": "Sunmi P2", "costo": 2264, "costoOriginal": 2830, "reembolso": 2264 },
          "ultra": { "nombre": "BP Ultra", "costo": 2264, "costoOriginal": 2830, "reembolso": 2264 }
        },
        "comodato": {
          "p2": { "nombre": "Sunmi P2", "costo": 0, "descripcion": "Gratuita con volumen mínimo" },
          "ultra": { "nombre": "BP Ultra", "costo": 0, "descripcion": "Gratuita con volumen mínimo" }
        }
      },
      "condicionesComodato": {
        "volumenMinimo": 100000,
        "descripcion": "Terminal gratuita con volumen mensual mínimo de $100,000 MXN"
      }
    },
    "feesAdicionales": {
      "contracargo": {
        "costo": 350,
        "moneda": "MXN",
        "descripcion": "Fee por contracargo procesado"
      },
      "chargeback": {
        "costo": 350,
        "moneda": "MXN",
        "descripcion": "Fee por chargeback procesado"
      }
    },
    "condicionesComerciales": {
      "liquidacion": {
        "local": "T+1 (siguiente día hábil)",
        "amex": "T+48h (2 días hábiles)",
        "internacional": "T+2 (2 días hábiles)"
      },
      "comisionesEscalera": {
        "hasta500k": 0.25,
        "hasta2500k": 0.35,
        "mayor2500k": 0.50
      },
      "requisitosDocumentales": [
        "Constancia de Situación Fiscal (actualizada)",
        "Identificación oficial del representante legal",
        "Comprobante de domicilio fiscal (no mayor a 3 meses)",
        "Estado de cuenta bancario (no mayor a 3 meses)",
        "Acta constitutiva (personas morales)",
        "Poder notarial (si aplica)"
      ]
    }
  };

  // Estados principales
  const [currentStep, setCurrentStep] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMCC, setSelectedMCC] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [showAllMCCs, setShowAllMCCs] = useState(false);
  
  // Datos del cliente
  const [clientData, setClientData] = useState({
    contactName: '',
    email: '',
    phone: '',
    businessName: '',
    legalName: '',
    monthlyVolume: '',
    averageTicket: '',
    operationType: '', // 'CP', 'CNP', 'BOTH'
  });

  // Servicios opcionales
  const [services, setServices] = useState({
    amex: false,
    international: false,
    msi: false
  });

  // Terminal (solo si aplica)
  const [terminal, setTerminal] = useState({
    required: false,
    modalidad: '', // 'compra', 'renta', 'seguro', 'comodato'
    tipo: '', // 'nano', 'p2', 'ultra'
  });

  // Precios
  const [prices, setPrices] = useState({
    tdLocal: '',
    tcLocal: '',
    amex: 3.00,
    international: 3.40,
    msi: 0 // Se calcula automáticamente
  });

  // MSI configuración
  const [msiConfig, setMsiConfig] = useState({
    emisor: 'Emisores PROSA',
    meses: '3'
  });

  // Ref para el PDF
  const proposalRef = useRef();

  // Palabras clave para búsqueda mejorada
  const giroKeywords = {
    'medico': [742, 8011, 8021],
    'doctor': [742, 8011, 8021],
    'consultorio': [742, 8011, 8021],
    'clinica': [742, 8011, 8021],
    'dentista': [742, 8011, 8021],
    'salud': [742, 8011, 8021],
    'restaurante': [5812, 5811],
    'comida': [5812, 5811],
    'gastronomia': [5812, 5811],
    'bar': [5812, 5811],
    'farmacia': [5912],
    'medicamento': [5912],
    'drogueria': [5912],
    'gasolina': [5541],
    'combustible': [5541],
    'estacion': [5541],
    'hotel': [7011],
    'hospedaje': [7011],
    'turismo': [7011],
    'supermercado': [5310],
    'super': [5310],
    'abarrotes': [5310],
    'gobierno': [4900],
    'municipal': [4900],
    'educacion': [8220, 8211],
    'colegio': [8220],
    'universidad': [8220],
    'escuela': [8220, 8211],
    'entretenimiento': [7032, 7941],
    'evento': [7941],
    'parque': [7032],
    'ropa': [5651, 5719],
    'textil': [5651, 5719],
    'moda': [5651, 5719],
    'calzado': [5719],
    'joyeria': [5094, 5944],
    'reloj': [5944],
    'electronico': [5732],
    'telefono': [4812],
    'programacion': [7372],
    'software': [7372],
    'belleza': [7230],
    'salon': [7230],
    'ferreteria': [5251],
    'construccion': [5251],
    'mensajeria': [4215],
    'courier': [4215],
    'transporte': [4789, 7512],
    'aereo': [4789],
    'casino': [7995],
    'apuesta': [7995],
    'electrodomestico': [5722],
    'mueble': [5712],
    'mascota': [5995],
    'floristeria': [5995],
    'panaderia': [5462],
    'papeleria': [5111]
  };

  // Función de búsqueda inteligente mejorada
  const searchMCC = (term) => {
    if (!term) {
      setSearchResults([]);
      return;
    }

    const termLower = term.toLowerCase().trim();
    const results = [];
    const foundMCCs = new Set();

    // Búsqueda por palabras clave
    Object.keys(giroKeywords).forEach(keyword => {
      if (termLower.includes(keyword)) {
        giroKeywords[keyword].forEach(mccCode => {
          const mccData = fullDatabase.mccDatabase.find(m => m.mcc === mccCode);
          if (mccData && !foundMCCs.has(mccCode)) {
            results.push({ ...mccData, relevance: 2 }); // Alta relevancia
            foundMCCs.add(mccCode);
          }
        });
      }
    });

    // Búsqueda por coincidencia en nombre del giro
    fullDatabase.mccDatabase.forEach(mccData => {
      const giroWords = mccData.giro.toLowerCase().split(/[\s\-\/]+/);
      const searchWords = termLower.split(/[\s\-\/]+/);
      
      let matches = 0;
      searchWords.forEach(searchWord => {
        if (giroWords.some(giroWord => giroWord.includes(searchWord) || searchWord.includes(giroWord))) {
          matches++;
        }
      });

      if (matches > 0 && !foundMCCs.has(mccData.mcc)) {
        results.push({ ...mccData, relevance: matches });
        foundMCCs.add(mccData.mcc);
      }
    });

    // Ordenar por relevancia
    results.sort((a, b) => b.relevance - a.relevance);
    setSearchResults(results.slice(0, 8)); // Máximo 8 resultados
  };

  // Calcular escalera de comisiones
  const getComissionRate = (volume) => {
    if (volume <= 500000) return fullDatabase.condicionesComerciales.comisionesEscalera.hasta500k;
    if (volume <= 2500000) return fullDatabase.condicionesComerciales.comisionesEscalera.hasta2500k;
    return fullDatabase.condicionesComerciales.comisionesEscalera.mayor2500k;
  };

  // Calcular comisiones
  const calculateCommissions = () => {
    if (!selectedMCC || !clientData.monthlyVolume) return null;

    const volume = parseFloat(clientData.monthlyVolume) || 0;
    const commissionRate = getComissionRate(volume);

    const tdPrice = parseFloat(prices.tdLocal) || selectedMCC.tdPiso;
    const tcPrice = parseFloat(prices.tcLocal) || (selectedMCC.tcPiso || 0);

    const tdUtility = (tdPrice - selectedMCC.tdCosto) / 100;
    const tcUtility = selectedMCC.tcCosto ? (tcPrice - selectedMCC.tcCosto) / 100 : 0;

    const tdCommission = volume * tdUtility * commissionRate;
    const tcCommission = volume * tcUtility * commissionRate;

    // Comisiones de servicios adicionales
    let amexCommission = 0;
    let internationalCommission = 0;
    
    if (services.amex) {
      const amexUtility = (fullDatabase.serviciosAdicionales.americanExpress.pisoMinimo - fullDatabase.serviciosAdicionales.americanExpress.costoTotal) / 100;
      amexCommission = volume * amexUtility * commissionRate;
    }

    if (services.international) {
      const intUtility = (fullDatabase.serviciosAdicionales.internacionales.pisoMinimoVariable - fullDatabase.serviciosAdicionales.internacionales.costoTotalVariable) / 100;
      internationalCommission = volume * intUtility * commissionRate;
    }

    const totalCommission = tdCommission + tcCommission + amexCommission + internationalCommission;

    return {
      volume,
      commissionRate: commissionRate * 100,
      tdUtility: tdUtility * 100,
      tcUtility: tcUtility * 100,
      tdCommission,
      tcCommission,
      amexCommission,
      internationalCommission,
      totalCommission
    };
  };

  // Función para enviar datos a XANO
  const sendToXano = async () => {
    try {
      // Preparar datos en el formato exacto que espera XANO
      const xanoData = {
        mcc: selectedMCC.mcc, // Número de 4 dígitos del MCC seleccionado
        contacto_nombre: clientData.contactName,
        contacto_email: clientData.email,
        contacto_telefono: parseInt(clientData.phone.replace(/\D/g, '')), // Convertir a entero, removiendo caracteres no numéricos
        nombre_comercial: clientData.businessName,
        razon_social: clientData.legalName,
        volumen_mensual: parseInt(clientData.monthlyVolume), // Convertir a entero
        ticket_promedio: parseFloat(clientData.averageTicket), // Convertir a decimal
        tipo_operacion: clientData.operationType, // CP, CNP, o BOTH
        costo_debito: parseFloat(prices.tdLocal), // Precio final de débito como decimal
        costo_credito: selectedMCC.tcPiso ? parseFloat(prices.tcLocal) : null, // Precio final de crédito o null si no aplica
        costo_amex: services.amex ? parseFloat(prices.amex) : null, // Precio AmEx o null si no está seleccionado
        costo_internacional: services.international ? parseFloat(prices.international) : null // Precio internacional o null si no está seleccionado
      };

      // URL del endpoint de XANO configurada
      const response = await fetch('https://xlgc-gbo3-1ulw.n7e.xano.io/api:9jjtjWgl/ejemplo_de_cotizaci_n', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(xanoData)
      });

      if (response.ok) {
        console.log('Datos enviados a XANO exitosamente:', xanoData);
        return true;
      } else {
        console.error('Error al enviar datos a XANO:', response.statusText);
        return false;
      }
    } catch (error) {
      console.error('Error de conexión con XANO:', error);
      return false;
    }
  };

  // Función para generar PDF mejorado
  const generatePDF = async () => {
    const element = proposalRef.current;
    
    // Enviar datos a XANO en el formato correcto
    const xanoSuccess = await sendToXano();
    
    if (xanoSuccess) {
      console.log('✅ Datos guardados en XANO correctamente');
    } else {
      console.warn('⚠️ Error al guardar en XANO, pero continuando con la generación del PDF');
    }

    const opt = {
      margin: 0.5,
      filename: `Propuesta_Payefy_${clientData.businessName.replace(/\s+/g, '_')}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    html2pdf().set(opt).from(element).save();
  };

  // Actualizar precios al cambiar MCC
  useEffect(() => {
    if (selectedMCC) {
      setPrices(prev => ({
        ...prev,
        tdLocal: selectedMCC.tdPiso.toFixed(2),
        tcLocal: selectedMCC.tcPiso ? selectedMCC.tcPiso.toFixed(2) : ''
      }));
    }
  }, [selectedMCC]);

  // Actualizar requerimiento de terminal
  useEffect(() => {
    const needsTerminal = clientData.operationType === 'CP' || clientData.operationType === 'BOTH';
    setTerminal(prev => ({ ...prev, required: needsTerminal }));
  }, [clientData.operationType]);

  // Calcular precio MSI
  useEffect(() => {
    if (services.msi && selectedMCC) {
      const sobretasa = fullDatabase.msiData.sobretasas[msiConfig.emisor][msiConfig.meses];
      if (sobretasa !== "No Aplica") {
        const baseRate = parseFloat(prices.tcLocal) || selectedMCC.tcPiso;
        const msiRate = baseRate + sobretasa;
        setPrices(prev => ({ ...prev, msi: msiRate.toFixed(2) }));
      }
    }
  }, [services.msi, msiConfig, prices.tcLocal, selectedMCC]);

  const commissionData = calculateCommissions();

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-green-800 mb-2">Calculadora Comercial Payefy</h1>
        <p className="text-gray-600">Sistema de generación de propuestas y cálculo de comisiones</p>
      </div>

      {/* Progress Bar */}
      <div className="mb-8">
        <div className="flex items-center justify-between text-sm">
          <span className={`${currentStep >= 1 ? 'text-green-600 font-semibold' : 'text-gray-400'}`}>1. Buscar Giro</span>
          <span className={`${currentStep >= 2 ? 'text-green-600 font-semibold' : 'text-gray-400'}`}>2. Datos Cliente</span>
          <span className={`${currentStep >= 3 ? 'text-green-600 font-semibold' : 'text-gray-400'}`}>3. Servicios</span>
          <span className={`${currentStep >= 4 ? 'text-green-600 font-semibold' : 'text-gray-400'}`}>4. Terminal</span>
          <span className={`${currentStep >= 5 ? 'text-green-600 font-semibold' : 'text-gray-400'}`}>5. Precios</span>
          <span className={`${currentStep >= 6 ? 'text-green-600 font-semibold' : 'text-gray-400'}`}>6. Propuesta</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
          <div className="bg-green-600 h-2 rounded-full transition-all duration-300" style={{width: `${(currentStep/6)*100}%`}}></div>
        </div>
      </div>

      {/* Step 1: Búsqueda de Giro */}
      {currentStep === 1 && (
        <div className="space-y-6">
          <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400">
            <h3 className="font-semibold text-blue-800 mb-2">💡 Tips para encontrar el giro correcto:</h3>
            <ul className="text-blue-700 text-sm space-y-1">
              <li>1. 📄 Solicita la "Constancia de Situación Fiscal" actualizada del cliente</li>
              <li>2. 🔍 Localiza la sección "Actividad Económica Predominante"</li>
              <li>3. ✍️ Escribe EXACTAMENTE como aparece en el documento fiscal</li>
              <li>4. 🤖 El sistema automáticamente asignará el MCC más adecuado</li>
            </ul>
          </div>

          <div className="bg-white border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4 flex items-center">
              <Search className="mr-2" size={20} />
              Buscar Giro/Actividad Económica
            </h2>
            
            <div className="flex gap-3 mb-4">
              <input
                type="text"
                placeholder="Ej: Servicios médicos, Restaurante de comida rápida, Farmacia..."
                className="flex-1 p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  searchMCC(e.target.value);
                }}
              />
              <button
                onClick={() => searchMCC(searchTerm)}
                className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
              >
                Buscar
              </button>
            </div>

            {/* Resultados de búsqueda */}
            {searchResults.length > 0 && (
              <div className="space-y-2 mb-4">
                <p className="text-sm text-gray-600">Resultados encontrados ({searchResults.length}):</p>
                <div className="max-h-64 overflow-y-auto space-y-2">
                  {searchResults.map((mcc) => (
                    <div
                      key={mcc.mcc}
                      className={`p-3 border rounded-lg cursor-pointer transition-colors ${
                        selectedMCC?.mcc === mcc.mcc ? 'bg-green-50 border-green-500' : 'hover:bg-gray-50'
                      }`}
                      onClick={() => setSelectedMCC(mcc)}
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <span className="font-semibold text-green-700">MCC {mcc.mcc}</span>
                          <p className="text-gray-700">{mcc.giro}</p>
                        </div>
                        <div className="text-right text-sm">
                          <p>TD: {mcc.tdPiso}%</p>
                          <p>TC: {mcc.tcPiso ? `${mcc.tcPiso}%` : 'N/A'}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Mensaje de no resultados */}
            {searchTerm && searchResults.length === 0 && (
              <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                <p className="text-yellow-800 mb-3">No se encontraron coincidencias automáticas.</p>
                <button
                  onClick={() => setShowAllMCCs(true)}
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  Ver lista completa de MCCs para selección manual
                </button>
              </div>
            )}

            {/* Mostrar todos los MCCs si no hay búsqueda */}
            {!searchTerm && (
              <div className="mt-4">
                <p className="text-gray-600 mb-3">O selecciona directamente de la lista completa:</p>
                <button
                  onClick={() => setShowAllMCCs(!showAllMCCs)}
                  className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                >
                  {showAllMCCs ? 'Ocultar' : 'Ver todos los MCCs'} ({fullDatabase.mccDatabase.length})
                </button>
              </div>
            )}

            {/* Lista completa de MCCs */}
            {showAllMCCs && (
              <div className="mt-4 max-h-96 overflow-y-auto space-y-2">
                {fullDatabase.mccDatabase.map((mcc) => (
                  <div
                    key={mcc.mcc}
                    className={`p-3 border rounded-lg cursor-pointer transition-colors ${
                      selectedMCC?.mcc === mcc.mcc ? 'bg-green-50 border-green-500' : 'hover:bg-gray-50'
                    }`}
                    onClick={() => setSelectedMCC(mcc)}
                  >
                    <div className="flex items-center justify-between">
                      <div>
                        <span className="font-semibold text-green-700">MCC {mcc.mcc}</span>
                        <p className="text-gray-700">{mcc.giro}</p>
                      </div>
                      <div className="text-right text-sm">
                        <p>TD: {mcc.tdPiso}%</p>
                        <p>TC: {mcc.tcPiso ? `${mcc.tcPiso}%` : 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* MCC Seleccionado */}
            {selectedMCC && (
              <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                <h3 className="font-semibold text-green-800 mb-2">✅ MCC Seleccionado:</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p><strong>MCC:</strong> {selectedMCC.mcc}</p>
                    <p><strong>Giro:</strong> {selectedMCC.giro}</p>
                  </div>
                  <div>
                    <p><strong>Tarjeta de Débito:</strong> {selectedMCC.tdPiso}%</p>
                    <p><strong>Tarjeta de Crédito:</strong> {selectedMCC.tcPiso ? `${selectedMCC.tcPiso}%` : 'No disponible'}</p>
                  </div>
                </div>
                <button
                  onClick={() => setCurrentStep(2)}
                  className="mt-4 px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                >
                  Continuar con Datos del Cliente
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Step 2: Datos del Cliente */}
      {currentStep === 2 && (
        <div className="space-y-6">
          <div className="bg-white border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4 flex items-center">
              <User className="mr-2" size={20} />
              Datos del Cliente
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nombre del Contacto *
                </label>
                <input
                  type="text"
                  className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  value={clientData.contactName}
                  onChange={(e) => setClientData(prev => ({ ...prev, contactName: e.target.value }))}
                  placeholder="Nombre completo del contacto"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email *
                </label>
                <input
                  type="email"
                  className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  value={clientData.email}
                  onChange={(e) => setClientData(prev => ({ ...prev, email: e.target.value }))}
                  placeholder="correo@empresa.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Teléfono *
                </label>
                <input
                  type="tel"
                  className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  value={clientData.phone}
                  onChange={(e) => setClientData(prev => ({ ...prev, phone: e.target.value }))}
                  placeholder="55 1234 5678"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nombre Comercial *
                </label>
                <input
                  type="text"
                  className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  value={clientData.businessName}
                  onChange={(e) => setClientData(prev => ({ ...prev, businessName: e.target.value }))}
                  placeholder="Como se conoce el negocio"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Razón Social *
                </label>
                <input
                  type="text"
                  className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  value={clientData.legalName}
                  onChange={(e) => setClientData(prev => ({ ...prev, legalName: e.target.value }))}
                  placeholder="Razón social según RFC"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Volumen Mensual (MXN) *
                </label>
                <input
                  type="number"
                  className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  value={clientData.monthlyVolume}
                  onChange={(e) => setClientData(prev => ({ ...prev, monthlyVolume: e.target.value }))}
                  placeholder="500000"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Ticket Promedio (MXN) *
                </label>
                <input
                  type="number"
                  className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  value={clientData.averageTicket}
                  onChange={(e) => setClientData(prev => ({ ...prev, averageTicket: e.target.value }))}
                  placeholder="1500"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Tipo de Operación *
                </label>
                <select
                  className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  value={clientData.operationType}
                  onChange={(e) => setClientData(prev => ({ ...prev, operationType: e.target.value }))}
                >
                  <option value="">Seleccionar...</option>
                  <option value="CP">Solo Presencial (CP)</option>
                  <option value="CNP">Solo En Línea (CNP)</option>
                  <option value="BOTH">Presencial + En Línea</option>
                </select>
              </div>
            </div>

            <div className="flex justify-between mt-6">
              <button
                onClick={() => setCurrentStep(1)}
                className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
              >
                Anterior
              </button>
              <button
                onClick={() => setCurrentStep(3)}
                disabled={!clientData.contactName || !clientData.email || !clientData.businessName || !clientData.monthlyVolume || !clientData.operationType}
                className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Step 3: Servicios Adicionales */}
      {currentStep === 3 && (
        <div className="space-y-6">
          <div className="bg-white border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4 flex items-center">
              <CreditCard className="mr-2" size={20} />
              Servicios Adicionales
            </h2>
            
            <div className="space-y-4">
              {/* American Express */}
              <div className="border rounded-lg p-4">
                <div className="flex items-center justify-between mb-2">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="mr-3 h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      checked={services.amex}
                      onChange={(e) => setServices(prev => ({ ...prev, amex: e.target.checked }))}
                    />
                    <span className="font-semibold">American Express</span>
                  </label>
                  <span className="text-green-600 font-semibold">3.00%</span>
                </div>
                <p className="text-sm text-gray-600 ml-7">
                  Procesamiento de tarjetas American Express. Liquidación en T+48h.
                </p>
              </div>

              {/* Tarjetas Internacionales */}
              <div className="border rounded-lg p-4">
                <div className="flex items-center justify-between mb-2">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="mr-3 h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      checked={services.international}
                      onChange={(e) => setServices(prev => ({ ...prev, international: e.target.checked }))}
                    />
                    <span className="font-semibold">Tarjetas Internacionales</span>
                  </label>
                  <span className="text-green-600 font-semibold">3.40%</span>
                </div>
                <p className="text-sm text-gray-600 ml-7">
                  Procesamiento de tarjetas emitidas fuera de México. Liquidación en T+2.
                </p>
              </div>

              {/* Meses Sin Intereses */}
              <div className="border rounded-lg p-4">
                <div className="flex items-center justify-between mb-2">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="mr-3 h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      checked={services.msi}
                      onChange={(e) => setServices(prev => ({ ...prev, msi: e.target.checked }))}
                    />
                    <span className="font-semibold">Meses Sin Intereses (MSI)</span>
                  </label>
                  <span className="text-green-600 font-semibold">Variable</span>
                </div>
                <p className="text-sm text-gray-600 ml-7 mb-3">
                  Permite a tus clientes pagar a meses sin intereses. Sobretasa según emisor y plazo.
                </p>
                
                {services.msi && (
                  <div className="ml-7 grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Emisor
                      </label>
                      <select
                        className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        value={msiConfig.emisor}
                        onChange={(e) => setMsiConfig(prev => ({ ...prev, emisor: e.target.value }))}
                      >
                        {Object.keys(fullDatabase.msiData.sobretasas).map(emisor => (
                          <option key={emisor} value={emisor}>{emisor}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Meses
                      </label>
                      <select
                        className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        value={msiConfig.meses}
                        onChange={(e) => setMsiConfig(prev => ({ ...prev, meses: e.target.value }))}
                      >
                        {Object.keys(fullDatabase.msiData.sobretasas[msiConfig.emisor]).map(meses => (
                          <option key={meses} value={meses}>{meses} meses</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="flex justify-between mt-6">
              <button
                onClick={() => setCurrentStep(2)}
                className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
              >
                Anterior
              </button>
              <button
                onClick={() => setCurrentStep(4)}
                className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Step 4: Terminal */}
      {currentStep === 4 && (
        <div className="space-y-6">
          <div className="bg-white border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4 flex items-center">
              <Building className="mr-2" size={20} />
              Terminal POS
            </h2>
            
            {terminal.required ? (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400">
                  <p className="text-blue-800">
                    <strong>Terminal requerida:</strong> Has seleccionado operación presencial, necesitas una terminal POS.
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-3">
                    Modalidad de Terminal *
                  </label>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {Object.entries(fullDatabase.terminales.costos).map(([modalidad, terminales]) => (
                      <div key={modalidad} className="space-y-2">
                        <h4 className="font-semibold capitalize">{modalidad}</h4>
                        {Object.entries(terminales).map(([tipo, info]) => (
                          <label key={tipo} className="flex items-center p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
                            <input
                              type="radio"
                              name="terminalOption"
                              className="mr-3 h-4 w-4 text-green-600 focus:ring-green-500"
                              checked={terminal.modalidad === modalidad && terminal.tipo === tipo}
                              onChange={() => setTerminal(prev => ({ ...prev, modalidad, tipo }))}
                            />
                            <div className="flex-1">
                              <div className="font-medium">{info.nombre}</div>
                              <div className="text-sm text-gray-600">{info.descripcion}</div>
                              <div className="text-sm font-semibold text-green-600">
                                {modalidad === 'renta' ? `$${info.costoMensual}/mes` : 
                                 modalidad === 'comodato' ? 'Gratuita*' : 
                                 `$${info.costo}`}
                              </div>
                            </div>
                          </label>
                        ))}
                      </div>
                    ))}
                  </div>
                  
                  {terminal.modalidad === 'comodato' && (
                    <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                      <p className="text-yellow-800 text-sm">
                        <strong>*Condiciones de Comodato:</strong> Terminal gratuita con volumen mensual mínimo de $100,000 MXN.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-gray-400">
                <p className="text-gray-700">
                  <strong>Terminal no requerida:</strong> Has seleccionado solo operación en línea (CNP).
                </p>
              </div>
            )}

            <div className="flex justify-between mt-6">
              <button
                onClick={() => setCurrentStep(3)}
                className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
              >
                Anterior
              </button>
              <button
                onClick={() => setCurrentStep(5)}
                disabled={terminal.required && (!terminal.modalidad || !terminal.tipo)}
                className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Step 5: Precios */}
      {currentStep === 5 && (
        <div className="space-y-6">
          <div className="bg-white border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4 flex items-center">
              <DollarSign className="mr-2" size={20} />
              Configuración de Precios
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Procesamiento Local */}
              <div className="space-y-4">
                <h3 className="font-semibold text-lg">Procesamiento Local</h3>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tarjeta de Débito (%)
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    value={prices.tdLocal}
                    onChange={(e) => setPrices(prev => ({ ...prev, tdLocal: e.target.value }))}
                    placeholder={selectedMCC?.tdPiso?.toString()}
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    Piso mínimo: {selectedMCC?.tdPiso}% | Costo: {selectedMCC?.tdCosto}%
                  </p>
                </div>
                
                {selectedMCC?.tcPiso && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Tarjeta de Crédito (%)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      value={prices.tcLocal}
                      onChange={(e) => setPrices(prev => ({ ...prev, tcLocal: e.target.value }))}
                      placeholder={selectedMCC?.tcPiso?.toString()}
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Piso mínimo: {selectedMCC?.tcPiso}% | Costo: {selectedMCC?.tcCosto}%
                    </p>
                  </div>
                )}
              </div>

              {/* Servicios Adicionales */}
              <div className="space-y-4">
                <h3 className="font-semibold text-lg">Servicios Adicionales</h3>
                
                {services.amex && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      American Express (%)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      value={prices.amex}
                      onChange={(e) => setPrices(prev => ({ ...prev, amex: parseFloat(e.target.value) }))}
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Piso mínimo: {fullDatabase.serviciosAdicionales.americanExpress.pisoMinimo}%
                    </p>
                  </div>
                )}
                
                {services.international && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Tarjetas Internacionales (%)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      value={prices.international}
                      onChange={(e) => setPrices(prev => ({ ...prev, international: parseFloat(e.target.value) }))}
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Piso mínimo: {fullDatabase.serviciosAdicionales.internacionales.pisoMinimoVariable}%
                    </p>
                  </div>
                )}
                
                {services.msi && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      MSI - {msiConfig.emisor} ({msiConfig.meses} meses)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="w-full p-3 border rounded-lg bg-gray-50"
                      value={prices.msi}
                      readOnly
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Calculado automáticamente: TC + {fullDatabase.msiData.sobretasas[msiConfig.emisor][msiConfig.meses]}%
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div className="flex justify-between mt-6">
              <button
                onClick={() => setCurrentStep(4)}
                className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
              >
                Anterior
              </button>
              <button
                onClick={() => setCurrentStep(6)}
                className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
              >
                Generar Propuesta
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Step 6: Propuesta Final */}
      {currentStep === 6 && (
        <div className="space-y-6">
          {/* Resumen de Comisiones (Solo para el asesor) */}
          {commissionData && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
              <h3 className="font-semibold text-yellow-800 mb-4 flex items-center">
                <AlertCircle className="mr-2" size={20} />
                Resumen de Comisiones (Confidencial - Solo Asesor)
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                <div>
                  <p className="font-medium">Volumen Mensual:</p>
                  <p>${commissionData.volume.toLocaleString()}</p>
                </div>
                <div>
                  <p className="font-medium">Escalera Comisión:</p>
                  <p>{commissionData.commissionRate}%</p>
                </div>
                <div>
                  <p className="font-medium">Comisión TD:</p>
                  <p>${commissionData.tdCommission.toLocaleString()}</p>
                </div>
                <div>
                  <p className="font-medium">Comisión Total:</p>
                  <p className="font-bold text-green-600">${commissionData.totalCommission.toLocaleString()}</p>
                </div>
              </div>
            </div>
          )}

          {/* Propuesta para el Cliente */}
          <div ref={proposalRef} className="bg-white border rounded-lg p-8" style={{ fontFamily: 'Arial, sans-serif' }}>
            {/* Header con Logo */}
            <div className="flex items-center justify-between mb-8 border-b pb-6">
              <div>
                {/* REEMPLAZAR CON TU LOGO REAL */}
                <img 
                  src="/path/to/your/payefy-logo.png" 
                  alt="Payefy Logo" 
                  className="h-12 w-auto"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <div style={{ display: 'none' }} className="text-2xl font-bold text-green-800">
                  PAYEFY
                </div>
              </div>
              <div className="text-right">
                <h1 className="text-2xl font-bold text-gray-800">PROPUESTA COMERCIAL</h1>
                <p className="text-gray-600">Fecha: {new Date().toLocaleDateString('es-MX')}</p>
              </div>
            </div>

            {/* Información del Cliente */}
            <div className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-green-600 pb-2">
                INFORMACIÓN DEL CLIENTE
              </h2>
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <p><strong>Nombre Comercial:</strong> {clientData.businessName}</p>
                  <p><strong>Razón Social:</strong> {clientData.legalName}</p>
                  <p><strong>Contacto:</strong> {clientData.contactName}</p>
                </div>
                <div>
                  <p><strong>Email:</strong> {clientData.email}</p>
                  <p><strong>Teléfono:</strong> {clientData.phone}</p>
                  <p><strong>Giro:</strong> {selectedMCC?.giro} (MCC {selectedMCC?.mcc})</p>
                </div>
              </div>
            </div>

            {/* Servicios Contratados */}
            <div className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-green-600 pb-2">
                SERVICIOS CONTRATADOS
              </h2>
              
              {/* Procesamiento Local */}
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-gray-700 mb-3">Procesamiento de Tarjetas Locales</h3>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p><strong>Tarjeta de Débito:</strong> {prices.tdLocal}%</p>
                      <p><strong>Liquidación:</strong> {fullDatabase.condicionesComerciales.liquidacion.local}</p>
                    </div>
                    {selectedMCC?.tcPiso && (
                      <div>
                        <p><strong>Tarjeta de Crédito:</strong> {prices.tcLocal}%</p>
                        <p><strong>Modalidades:</strong> {clientData.operationType === 'CP' ? 'Presencial' : clientData.operationType === 'CNP' ? 'En Línea' : 'Presencial + En Línea'}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Servicios Adicionales */}
              {(services.amex || services.international || services.msi) && (
                <div className="mb-6">
                  <h3 className="text-lg font-semibold text-gray-700 mb-3">Servicios Adicionales</h3>
                  <div className="space-y-3">
                    {services.amex && (
                      <div className="bg-blue-50 p-4 rounded-lg">
                        <p><strong>American Express:</strong> {prices.amex}%</p>
                        <p className="text-sm text-gray-600">Liquidación: {fullDatabase.serviciosAdicionales.americanExpress.liquidacion}</p>
                      </div>
                    )}
                    {services.international && (
                      <div className="bg-blue-50 p-4 rounded-lg">
                        <p><strong>Tarjetas Internacionales:</strong> {prices.international}%</p>
                        <p className="text-sm text-gray-600">Liquidación: {fullDatabase.condicionesComerciales.liquidacion.internacional}</p>
                      </div>
                    )}
                    {services.msi && (
                      <div className="bg-blue-50 p-4 rounded-lg">
                        <p><strong>Meses Sin Intereses:</strong> {prices.msi}%</p>
                        <p className="text-sm text-gray-600">Configuración: {msiConfig.emisor} - {msiConfig.meses} meses</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Terminal */}
              {terminal.required && terminal.modalidad && (
                <div className="mb-6">
                  <h3 className="text-lg font-semibold text-gray-700 mb-3">Terminal POS</h3>
                  <div className="bg-green-50 p-4 rounded-lg">
                    <p><strong>Modelo:</strong> {fullDatabase.terminales.costos[terminal.modalidad][terminal.tipo].nombre}</p>
                    <p><strong>Modalidad:</strong> {terminal.modalidad.charAt(0).toUpperCase() + terminal.modalidad.slice(1)}</p>
                    <p><strong>Costo:</strong> {
                      terminal.modalidad === 'renta' ? `$${fullDatabase.terminales.costos[terminal.modalidad][terminal.tipo].costoMensual}/mes` :
                      terminal.modalidad === 'comodato' ? 'Gratuita (con volumen mínimo)' :
                      `$${fullDatabase.terminales.costos[terminal.modalidad][terminal.tipo].costo}`
                    }</p>
                    <p className="text-sm text-gray-600">{fullDatabase.terminales.costos[terminal.modalidad][terminal.tipo].descripcion}</p>
                  </div>
                </div>
              )}
            </div>

            {/* Condiciones Comerciales */}
            <div className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-green-600 pb-2">
                CONDICIONES COMERCIALES
              </h2>
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold mb-2">Liquidación de Fondos:</h4>
                  <ul className="text-sm space-y-1">
                    <li>• Tarjetas Locales: {fullDatabase.condicionesComerciales.liquidacion.local}</li>
                    {services.amex && <li>• American Express: {fullDatabase.condicionesComerciales.liquidacion.amex}</li>}
                    {services.international && <li>• Internacionales: {fullDatabase.condicionesComerciales.liquidacion.internacional}</li>}
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold mb-2">Fees Adicionales:</h4>
                  <ul className="text-sm space-y-1">
                    <li>• Contracargo: ${fullDatabase.feesAdicionales.contracargo.costo} {fullDatabase.feesAdicionales.contracargo.moneda}</li>
                    <li>• Chargeback: ${fullDatabase.feesAdicionales.chargeback.costo} {fullDatabase.feesAdicionales.chargeback.moneda}</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Requisitos Documentales */}
            <div className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-green-600 pb-2">
                REQUISITOS DOCUMENTALES
              </h2>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-semibold mb-3">Para completar el proceso de afiliación, necesitaremos:</p>
                <ul className="text-sm space-y-2">
                  {fullDatabase.condicionesComerciales.requisitosDocumentales.map((req, index) => (
                    <li key={index} className="flex items-start">
                      <CheckCircle className="mr-2 mt-0.5 text-green-600 flex-shrink-0" size={16} />
                      {req}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Footer */}
            <div className="border-t pt-6 text-center text-sm text-gray-600">
              <p className="mb-2">Esta propuesta tiene vigencia de 30 días a partir de la fecha de emisión.</p>
              <p>Para más información, contacta a tu asesor comercial Payefy.</p>
              <div className="mt-4 text-xs">
                <p>Payefy - Soluciones de Pago Integrales</p>
                <p>www.payefy.com | contacto@payefy.com</p>
              </div>
            </div>
          </div>

          {/* Botones de Acción */}
          <div className="flex justify-between">
            <button
              onClick={() => setCurrentStep(5)}
              className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
            >
              Anterior
            </button>
            <div className="space-x-4">
              <button
                onClick={() => setCurrentStep(1)}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Nueva Cotización
              </button>
              <button
                onClick={generatePDF}
                className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center"
              >
                <Download className="mr-2" size={20} />
                Descargar PDF
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalculadoraComercialPayefy;

